export * from './buttons.tmpl';
export * from './consent.tmpl';
export * from './consentOverview.tmpl';
export * from './features.tmpl';
export * from './group.tmpl';
export * from './history.tmpl';
export * from './historyItem.tmpl';
export * from './main.tmpl';
export * from './pagination.tmpl';
export * from './referenceItem.tmpl';
export * from './references.tmpl';
export * from './tefComsCustomerAttribute.tmpl';
export * from './tooltip.tmpl';
export * from './triStateButton.tmpl';
export * from './triStateButtonsPart.tmpl';
